import { Injectable } from "@angular/core";
import JSEncrypt from "jsencrypt";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  encryptValue(value: string, publicKey: string): string | false {
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(publicKey);
    return encryptor.encrypt(value);
  }
}